// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"a3415a28","915":"cedc8b53"}[chunkId] + ".chunk.css";
};